import { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'components/UI/Modal/Modal';
import { CloseButton } from 'components/UI/CloseButton/CloseButton';
import { SearchContext } from 'components/SearchFormAndResults/SearchFormAndResultsProvider';
import { SearchModalControls } from './SearchModalControls';
import { SearchModalCheckboxes } from './SearchModalCheckboxes';
import './SearchFilterModal.scss';

export const SearchFilterModal = (props) => {
  const { closeModalHandler, modalIsOpen } = props;
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [applyFiltersButtonDisabled, setApplyFiltersButtonDisabled] = useState(true);
  const { searchFilters, modalApplyFiltersButtonHandler } = useContext(SearchContext);

  useEffect(() => {
    const selectedFilters = searchFilters
      ?.map((filter) => filter.selected && filter.id)
      .filter(Boolean);
    setSelectedCheckboxes(selectedFilters);
  }, [searchFilters]);

  const applyFiltersButtonHandler = () => {
    modalApplyFiltersButtonHandler(selectedCheckboxes);
    setApplyFiltersButtonDisabled(true);
    closeModalHandler();
  };

  const clearAllFiltersHandler = () => {
    modalApplyFiltersButtonHandler();
    setApplyFiltersButtonDisabled(true);
    closeModalHandler();
  };

  return (
    <Modal
      extendClass="search-filter-modal"
      open={modalIsOpen}
      closeModalHandler={closeModalHandler}
    >
      <CloseButton
        text="Close"
        extendClass="search-filter-modal__btn-close hidden-xs"
        onClick={closeModalHandler}
      />

      <div className="search-filter-modal__filters container">
        <div className="filter-label h4">Result types</div>
        <SearchModalCheckboxes
          searchFilters={searchFilters}
          selectedCheckboxes={selectedCheckboxes}
          setSelectedCheckboxes={setSelectedCheckboxes}
          setApplyFiltersButtonDisabled={setApplyFiltersButtonDisabled}
        />
      </div>

      <SearchModalControls
        selectedCheckboxes={selectedCheckboxes}
        closeModalHandler={closeModalHandler}
        clearAllFiltersHandler={clearAllFiltersHandler}
        applyFiltersButtonDisabled={applyFiltersButtonDisabled}
        applyFiltersButtonHandler={applyFiltersButtonHandler}
      />
    </Modal>
  );
};

SearchFilterModal.propTypes = {
  closeModalHandler: PropTypes.func,
  modalIsOpen: PropTypes.bool,
};
